import { useMemo } from 'react';

function detectDevice() {
    if (typeof navigator === 'undefined') {
        return { isPhone: false, isTablet: false, isDesktop: true };
    }

    const ua = navigator.userAgent || '';
    const maxTouch = navigator.maxTouchPoints || 0;

    const isIPhone = /iPhone|iPod/.test(ua);
    // iPadOS 13+ reports as "Macintosh" — disambiguate via maxTouchPoints.
    const isIPad = /iPad/.test(ua) || (/Macintosh/.test(ua) && maxTouch > 1);
    const isAndroid = /Android/.test(ua);
    const isAndroidPhone = isAndroid && /Mobile/.test(ua);
    const isAndroidTablet = isAndroid && !/Mobile/.test(ua);

    const isPhone = isIPhone || isAndroidPhone;
    const isTablet = isIPad || isAndroidTablet;
    const isDesktop = !isPhone && !isTablet;

    return { isPhone, isTablet, isDesktop };
}

export const useDevice = () => {
    return useMemo(detectDevice, []);
};
